import { useRootSelector } from '../../../../../../store/hooks';
import { Trans, useTranslation } from 'react-i18next';
import { selectSitePricingProductsData } from '../../../../store/features/products';
import Tooltip from '../../../../shared/library/Tooltip';
import Typography from '../../../../shared/library/Typography';
import DiscountBanner from '../../../../shared/components/DiscountBanner';

export default function TierDiscountBanner() {
  const { t } = useTranslation();
  const { tier } = useRootSelector(selectSitePricingProductsData);
  const bannerEnabled =
    tier.displayPricingTierSummary &&
    Boolean(tier.endDate) &&
    Boolean(tier.maxSaving);

  if (!bannerEnabled) {
    return null;
  }

  return (
    <Tooltip
      title={t('site.pricing.products-selection.discount-banner.tooltip.title')}
    >
      <DiscountBanner className="informa-payment-tier-discount-banner">
        <Typography
          variant="featuredText"
          component="span"
          neutralColorIndex={0}
          className="informa-payment-tier-discount-banner__content"
        >
          <Trans
            i18nKey="site.pricing.products-selection.discount-banner.title"
            values={{ 0: tier.maxSaving, 1: tier.endDate }}
            components={{ bold: <strong /> }}
          />
        </Typography>
      </DiscountBanner>
    </Tooltip>
  );
}
